<template>
  <div>
    <v-row class="ma-0 my-4 align-center justify-space-between">
      <h1 class="text-h5 font-weight-bold">Planes</h1>
      <v-dialog
        v-model="showDialog"
        min-width="600"
        max-width="1180"
        min-height="600"
        max-height="900"
        @keydown.esc="closeDialog"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-if="can('plans:create')"
            class="d-none d-md-block"
            rounded
            color="primary"
            depressed
            v-bind="attrs"
            v-on="on"
          >
            <span class="d-none d-md-block">Agregar Plan</span>
          </v-btn>
          <v-btn
            v-if="can('plans:create')"
            class="d-block d-md-none"
            rounded
            color="primary"
            fab
            depressed
            x-small
            v-bind="attrs"
            v-on="on"
          >
            <v-icon dark> mdi-plus </v-icon>
          </v-btn>
        </template>
        <template>
          <plan-maintainer
            :plan="selectedPlan"
            @update-list="getPlans(this.page, this.limit)"
            @close-dialog="closeDialog"
          ></plan-maintainer>
        </template>
      </v-dialog>

      <v-dialog
        v-model="deleteDialog"
        min-width="600"
        max-width="900"
        min-height="600"
        max-height="900"
        @keydown.esc="closeDialog"
      >
        <template>
          <v-card class="pa-6">
            <v-card-title class="text-uppercase">
              <div>Eliminar plan {{ selectedPlan != null ? selectedPlan.name : '' }}</div>
            </v-card-title>
            <hr class="my-3" />
            <v-card-text class="my-0 py-0">
              <p>¿Está seguro de que desea eliminar el plan?</p>
            </v-card-text>
            <hr class="my-3" />
            <v-card-actions class="justify-end">
              <v-btn text color="primary" rounded @click="closeDialog">Cancelar</v-btn>
              <v-btn color="primary" rounded @click="deletePlan(selectedPlan)">
                Sí, eliminar
              </v-btn>
            </v-card-actions>
          </v-card>
        </template>
      </v-dialog>
    </v-row>
    <v-data-table
      :headers="headers"
      :items="plans"
      :loading="loadingData"
      :options.sync="options"
      :items-per-page="limit"
      :server-items-length="totalItems"
      class="elevation-1"
      :footer-props="{
        'items-per-page-options': [5, 10, 20, 30, 40, 50]
      }"
    >
      <template v-slot:top>
        <v-row dense class="px-5 py-5" align="center">
          <v-col cols="12" md>
            <v-text-field
              v-model="search"
              label="Buscar plan"
              prepend-inner-icon="mdi-magnify"
              :disabled="loadingData"
              dense
              outlined
              clearable
              hide-details
              @click:clear="cleanSearch"
              @keyup="cleanSearch"
              @keyup.enter="searchFn"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="auto" style="min-width: 180px">
            <v-select
              v-model="filterCountryId"
              :items="countries"
              item-text="name"
              item-value="id"
              :loading="loadingCountries"
              label="País"
              dense
              outlined
              clearable
              hide-details
            ></v-select>
          </v-col>
          <v-col cols="12" md="auto" style="min-width: 160px">
            <v-select
              v-model="filterCurrency"
              :items="currencyOptions"
              label="Moneda"
              dense
              outlined
              clearable
              hide-details
            ></v-select>
          </v-col>
          <v-col cols="12" md="auto" class="d-flex align-center" style="min-width: 260px">
            <v-btn-toggle v-model="filterVisible" mandatory dense borderless class="flex-grow-1">
              <v-btn
                value="hidden"
                x-small
                :color="filterVisible === 'hidden' ? 'error' : undefined"
                :class="filterVisible === 'hidden' ? 'flex-grow-1 white--text' : 'flex-grow-1 grey--text text--lighten-1'"
              >
                No visibles
              </v-btn>
              <v-btn
                value="all"
                x-small
                :class="filterVisible === 'all' ? 'flex-grow-1' : 'flex-grow-1 grey--text text--lighten-1'"
              >
                Todos
              </v-btn>
              <v-btn
                value="visible"
                x-small
                :color="filterVisible === 'visible' ? 'success' : undefined"
                :class="filterVisible === 'visible' ? 'flex-grow-1 white--text' : 'flex-grow-1 grey--text text--lighten-1'"
              >
                Visibles
              </v-btn>
            </v-btn-toggle>
          </v-col>
        </v-row>
      </template>
      <template v-slot:item.name="{ item }">
        <div>
          <p class="font-weight-bold ma-0">{{ item.name }}</p>
        </div>
      </template>
      <template v-slot:item.internalDescription="{ item }">
        <v-tooltip top :disabled="!item.internalDescription">
          <template v-slot:activator="{ on, attrs }">
            <div class="text-truncate" style="max-width: 220px" v-bind="attrs" v-on="on">
              {{ item.internalDescription }}
            </div>
          </template>
          <span>{{ item.internalDescription }}</span>
        </v-tooltip>
      </template>
      <template v-slot:item.annualPrice="{ item }">
        <div v-if="item.annualPrice != null">
          <span>{{ formatPrice(item.annualPrice, item.currency) }}</span>
        </div>
      </template>
      <template v-slot:item.monthlyPrice="{ item }">
        <div v-if="item.monthlyPrice != null">
          <span>{{ formatPrice(item.monthlyPrice, item.currency) }}</span>
        </div>
      </template>
      <template v-slot:item.animalType="{ item }">
        <v-chip
          v-if="item.animalType === 'cat' || item.animalType === null"
          small
          color="green"
          class="white--text font-weight-bold"
          ><v-icon left> mdi-cat </v-icon> Gato</v-chip
        >
        <v-chip
          v-if="item.animalType === 'dog' || item.animalType === null"
          small
          color="orange"
          class="white--text font-weight-bold"
          ><v-icon left> mdi-dog </v-icon> Perro</v-chip
        >
      </template>
      <template v-slot:item.visible="{ item }">
        <v-icon color="green" v-if="item.visible">mdi-check-circle</v-icon>
        <v-icon color="red" v-if="!item.visible">mdi-close-circle</v-icon>
      </template>
      <template v-slot:item.actions="{ item }">
        <div class="d-flex flex-nowrap align-center">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="mx-1"
                fab
                dark
                depressed
                x-small
                v-bind="attrs"
                v-on="on"
                color="blue"
                :to="{ name: 'PlanDetails', params: { planId: item.id } }"
              >
                <v-icon small dark>mdi-eye</v-icon>
              </v-btn>
            </template>
            <span>Servicios</span>
          </v-tooltip>
          <v-tooltip v-if="can('plans:update')" top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="mx-1"
                fab
                dark
                depressed
                x-small
                v-bind="attrs"
                v-on="on"
                color="orange"
                @click="openDialog(item)"
              >
                <v-icon small dark>mdi-pencil</v-icon>
              </v-btn>
            </template>
            <span>Editar plan</span>
          </v-tooltip>
          <v-tooltip v-if="can('plans:delete')" top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="mx-1"
                fab
                dark
                x-small
                depressed
                v-bind="attrs"
                v-on="on"
                color="pink"
                @click="triggerDeleteModal(item)"
              >
                <v-icon small dark>mdi-delete-forever</v-icon>
              </v-btn>
            </template>
            <span>Eliminar</span>
          </v-tooltip>
        </div>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import PlanMaintainer from '../components/PlanMaintainer';
import PlansService from '../services/plans.service';
import CountryService from '../services/countries.service';
import { can } from '../utils/permissions';

export default {
  components: {
    PlanMaintainer
  },
  data() {
    return {
      search: '',
      showDialog: false,
      deleteDialog: false,
      selectedPlan: null,
      loadingData: false,
      options: {},
      plans: [],
      filterVisible: 'visible',
      filterCountryId: null,
      filterCurrency: null,
      countries: [],
      loadingCountries: false,
      currencyOptions: ['CLP', 'UF', 'USD', 'PEN', 'MXN'],
      limit: 10,
      page: 1,
      totalItems: 0,
      headers: [
        {
          text: 'Plan',
          sortable: true,
          value: 'name'
        },
        {
          text: 'Descripción interna',
          sortable: false,
          value: 'internalDescription'
        },
        {
          text: 'Valor anual (iva inc.)',
          sortable: false,
          value: 'annualPrice'
        },
        {
          text: 'Valor mensual (iva inc.)',
          sortable: false,
          value: 'monthlyPrice'
        },
        {
          text: 'Visible',
          sortable: false,
          value: 'visible'
        },
        {
          text: 'Acciones',
          value: 'actions',
          sortable: false,
          width: '132px'
        }
      ]
    };
  },
  watch: {
    options: {
      handler() {
        this.page = this.options.page;
        this.limit = this.options.itemsPerPage;
        this.getPlans(this.page, this.limit);
      },
      deep: true
    },
    filterVisible() {
      this.page = 1;
      this.options = { ...this.options, page: 1 };
    },
    filterCountryId() {
      this.page = 1;
      this.options = { ...this.options, page: 1 };
    },
    filterCurrency() {
      this.page = 1;
      this.options = { ...this.options, page: 1 };
    }
  },
  created() {
    this.loadCountries();
  },
  methods: {
    can,
    formatPrice(value, currency) {
      const formatted = Number(value ?? 0).toLocaleString('es-CL', { maximumFractionDigits: 2 });
      return `${formatted} ${currency}`;
    },
    async loadCountries() {
      this.loadingCountries = true;
      try {
        const res = await CountryService.getAllCountries(true);
        this.countries = res.status === 'ok' ? res.data || [] : [];
      } catch (error) {
        console.log(error);
        this.countries = [];
      } finally {
        this.loadingCountries = false;
      }
    },
    async searchFn() {
      this.sort = [];
      this.getPlans(1, 10, this.search);
    },
    async cleanSearch() {
      if (!this.search || this.search.length === 0) {
        this.sort = [];
        this.getPlans(1, 10, '');
      }
    },
    async getPlans(page, limit) {
      this.loadingData = true;
      const visible = this.filterVisible === 'visible' ? true : this.filterVisible === 'hidden' ? false : null;
      const sortBy = this.options.sortBy && this.options.sortBy[0];
      const sortDesc = this.options.sortDesc && this.options.sortDesc[0];
      const res = await PlansService.getPlans(
        page,
        limit,
        this.search,
        visible,
        sortBy,
        sortDesc,
        this.filterCountryId,
        this.filterCurrency
      );
      if (res.status === 'ok') {
        this.plans = res.data.plans;
        this.totalItems = res.data.totalItems;
      }
      this.loadingData = false;
    },
    async openDialog(plan) {
      const res = await PlansService.getPlanDetails(plan.id);
      this.selectedPlan = res.status === 'ok' ? res.data : plan;
      this.showDialog = true;
    },
    closeDialog() {
      this.getPlans(this.page, this.limit);
      this.showDialog = false;
      this.deleteDialog = false;
      this.selectedPlan = null;
    },
    async deletePlan(plan) {
      this.loadingData = true;
      const res = await PlansService.deletePlan(plan.id);
      if (res.status === 'ok') {
        this.closeDialog();
      }
      this.loadingData = false;
    },
    triggerDeleteModal(plan) {
      this.deleteDialog = true;
      this.selectedPlan = plan;
    }
  }
};
</script>
